import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Input,
  RadioButtonGroup,
} from '@roger/ui-components';
import { THICKNESS_OPTIONS } from '../../../constants/wounds';
import type { ThicknessState } from '../assessmentFormTypes';

interface ThicknessSectionProps {
  state: ThicknessState;
  onChange: (update: Partial<ThicknessState>) => void;
}

const ThicknessSection: React.FC<ThicknessSectionProps> = ({
  state,
  onChange,
}) => (
  <AccordionItem value='thickness' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Thickness
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-2'>
      <RadioButtonGroup
        options={THICKNESS_OPTIONS.map(o => ({
          value: o.value,
          label: o.label,
        }))}
        value={state.value}
        onValueChange={v =>
          onChange({
            value: v,
            ...(v !== 'other' && { other: '' }),
            ...(v !== 'unable_to_determine' && { notAssessedReason: '' }),
          })
        }
      />
      {state.value === 'unable_to_determine' && (
        <Input
          placeholder='Reason not assessed...'
          value={state.notAssessedReason}
          onChange={e => onChange({ notAssessedReason: e.target.value })}
          inputSize='sm'
        />
      )}
      {state.value === 'other' && (
        <Input
          placeholder='Describe thickness...'
          value={state.other}
          onChange={e => onChange({ other: e.target.value })}
          inputSize='sm'
        />
      )}
    </AccordionContent>
  </AccordionItem>
);

export default ThicknessSection;
